import { store } from '@/store'
import { assetApi } from '@/store/services'
import { redirect } from 'react-router-dom'
import { list } from '../utils'

export const AssetCreateAction = async (args) => {
  const { request } = args
  const params = await request.json()
  try {
    await store.dispatch(
      assetApi.endpoints.createAsset.initiate(params)
    ).unwrap()

    return redirect(list('assets'))
  } catch (err) {
    return err
  }
}

export const AssetEditAction = async (args) => {
  const { request } = args
  const params = await request.json()
  try {
    await store.dispatch(
      assetApi.endpoints.updateAsset.initiate(params)
    ).unwrap()

    if (request.method === 'PUT') return redirect(list('assets'))

    return null
  } catch (err) {
    return err
  }
}
